import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import ProgressBar from "../components/ProgressBar";
import maleImg from "../images/mr.png";
import femaleImg from "../images/ms.png";

const Step1 = () => {
  const student = JSON.parse(localStorage.getItem("student"));
  const [loading, setLoading] = useState(false);
  const [selectedGender, setSelectedGender] = useState("");

  const handleSelectGender = async (gender) => {
    if (!student) {
      alert("Student data not found. Please login again.");
      window.location.href = "/login";
      return;
    }

    setSelectedGender(gender);
    setLoading(true);

    try {
      const response = await fetch(
       `http://localhost:3000/api/student-demography/${student.student_id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            gender,
            current_step: "2", // <--- TAMBAHAN WAJIB
          }),
        }
      );

      if (response.ok) {
        // Delay kecil untuk transisi smooth
        setTimeout(() => {
          window.location.href = "/step2";
        }, 800);
      } else {
        const data = await response.json();
        console.error("Save error:", data);
        alert("Failed to save gender. Please try again.");
      }
    } catch (error) {
      console.error("Error updating gender:", error);
      alert("Error connecting to the server.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-b from-blue-800 via-blue-700 to-blue-400 text-white px-4 text-center">
      {/* Progress bar */}
      <div className="w-full max-w-lg mt-6 z-20">
        <ProgressBar step={1} />
      </div>

      {/* Judul */}
      <motion.h1
        className="text-3xl md:text-4xl font-extrabold mt-10  text-yellow-300 text-center drop-shadow-md"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        How do you identify yourself?
      </motion.h1>

      {/* Pilihan Gender */}
      <div className="flex flex-col md:flex-row items-center justify-center gap-12">
        {/* Mr Option */}
        <motion.div
          className={`flex flex-col items-center cursor-pointer rounded-2xl p-4 ${
            selectedGender === "Male"
              ? "bg-yellow-400/30 ring-4 ring-yellow-300"
              : ""
          }`}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => handleSelectGender("Male")}
        >
          <img
            src={maleImg}
            alt="Mr"
            className={`w-40 h-50 md:w-50 md:h-50 drop-shadow-lg ${
              loading && selectedGender === "Male" ? "opacity-60" : ""
            }`}
          />
          <p className="text-yellow-300 text-2xl font-bold mt-4">
            {loading && selectedGender === "Male" ? "Saving..." : "Mr."}
          </p>
        </motion.div>

        {/* Ms/Mrs Option */}
        <motion.div
          className={`flex flex-col items-center cursor-pointer rounded-2xl p-4 ${
            selectedGender === "Female"
              ? "bg-yellow-400/30 ring-4 ring-yellow-300"
              : ""
          }`}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => handleSelectGender("Female")}
        >
          <img
            src={femaleImg}
            alt="Ms/Mrs"
            className={`w-40 h-50 md:w-48 md:h-50 drop-shadow-lg ${
              loading && selectedGender === "Female" ? "opacity-60" : ""
            }`}
          />
          <p className="text-yellow-300 text-2xl font-bold mt-4">
            {loading && selectedGender === "Female" ? "Saving..." : "Ms/Mrs"}
          </p>
        </motion.div>
      </div>

      {/* Info Footer */}
      <AnimatePresence>
        {!loading && (
          <motion.p
            key="info"
            className="text-blue-100 text-sm mt-7"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
          >
            Select one option to continue ✨
          </motion.p>
        )}
      
	  {/* Footer */}
      <p className="absolute bottom-4 text-blue-200 text-xs">
        © 2025 Universitas Terbuka
      </p>
	  
	  </AnimatePresence>
	  
	  
    </div>
  );
};

export default Step1;
